import { useState } from "react";

export function useTableSelection<T extends { id: number }>({ data }: { data?: T[] }) {
  const [selectedItems, setSelectedItems] = useState<T[]>([]);
  const selectedKeys = selectedItems.map((x) => x.id);

  const onSelectedKeysChange = (keys: number[]) => {
    setSelectedItems((currentItems) => {
      let itemsOnOtherPages = [
        ...currentItems.filter((x) => !data?.map((x) => x.id).includes(x.id)),
      ];
      return [...itemsOnOtherPages, ...(data?.filter((item) => keys.includes(item.id)) || [])];
    });
  };

  return { selectedItems, selectedKeys, setSelectedItems, onSelectedKeysChange };
}
